import type { RefObject } from 'react'
import { useEffect, useRef } from 'react'
import type { OrbitControls as OrbitControlsImpl } from 'three-stdlib'
import type { MotionSequence } from '../types'

type Props = {
  controlsRef: RefObject<OrbitControlsImpl | null>
  restartKey?: MotionSequence['restartKey']
}

export const useOrbitControlsAutoCorrection = ({ controlsRef, restartKey }: Props) => {
  const isAutoCorrectionSuspendedRef = useRef(false)
  const previousRestartKeyRef = useRef(restartKey)

  useEffect(() => {
    if (previousRestartKeyRef.current !== restartKey) {
      previousRestartKeyRef.current = restartKey
      isAutoCorrectionSuspendedRef.current = false
    }
  }, [restartKey])

  useEffect(() => {
    const controls = controlsRef.current
    if (!controls) return

    const handleStart = () => {
      isAutoCorrectionSuspendedRef.current = true
    }

    const handleEnd = () => {
      isAutoCorrectionSuspendedRef.current = true
    }

    controls.addEventListener('start', handleStart)
    controls.addEventListener('end', handleEnd)

    return () => {
      controls.removeEventListener('start', handleStart)
      controls.removeEventListener('end', handleEnd)
    }
  }, [controlsRef])

  return {
    isAutoCorrectionSuspendedRef,
  }
}
